import * as entity from '@common/domain/entities/Site'
export class SiteEndPoints extends entity.SiteEndPoints {}

export class SiteFormFields extends entity.SiteFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
       if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
       if (this["changedBy"]) this.splice(this.indexOf(this["changedBy"]), 1)
       if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
    } catch  { }
  }
}

export class SiteForm extends entity.SiteForm {
  protected siteFormEndPoints: SiteEndPoints = new SiteEndPoints();
  protected siteFormFields: SiteFormFields = new SiteFormFields();
}

export class SiteListColumns extends entity.SiteListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
          if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
          if (this["changedBy"]) this.splice(this.indexOf(this["changedBy"]), 1)
          if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
    } catch  { }
  }
}

export class SiteList extends entity.SiteList {
  protected siteListEndPoints: SiteEndPoints = new SiteEndPoints();
  protected siteListColumns: SiteListColumns = new SiteListColumns();
}

export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
    }
  }
}
